<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="兑换比设置" name="Exchange"><Exchange /></el-tab-pane>
      <el-tab-pane label="用户支付设置" name="UserPay"><UserPay /></el-tab-pane>
      <el-tab-pane label="短信通知设置" name="Notice"><Notice /></el-tab-pane>
      <el-tab-pane label="广告位设置" name="Banner"><Banner /></el-tab-pane>
      <!-- <el-tab-pane label="弹窗消息设置" name="PushWindow"
        ><PushWindow
      /></el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import Exchange from './exchange'
import UserPay from './userPay'
import Notice from './notice'
import Banner from './banner'
// import PushWindow from './pushWindow'
export default {
  components: {
    Exchange,
    UserPay,
    Notice,
    Banner,
    // PushWindow
  },
  data() {
    return {
      activeName: 'Exchange',
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
}
</style>
